import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { hasMany, references } from '@apexdesigner/schema-tools';

export const resourceSet = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    name: z.string().nullable().optional().describe('Name'),

    locked: z.boolean().nullable().optional().hidden().describe('locked'),

    uuid: z.string().nullable().optional().hidden().describe('uuid'),

    version: z.number().nullable().optional().hidden().describe('version'),

    status: z.string().nullable().optional().hidden().describe('status'),

    createdAt: z.coerce
      .date()
      .nullable()
      .optional()
      .hidden()
      .describe('createdAt'),

    publishedAt: z.coerce
      .date()
      .nullable()
      .optional()
      .hidden()
      .describe('publishedAt'),

    archivedAt: z.coerce
      .date()
      .nullable()
      .optional()
      .hidden()
      .describe('archivedAt'),

    createdById: z
      .number()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to User'),

    publishedById: z
      .number()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to User'),

    archivedById: z
      .number()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to User'),

    resourceCategories: hasMany('ResourceCategory'),

    activityItems: hasMany('ActivityItem'),

    createdBy: references('User'),

    publishedBy: references('User'),

    archivedBy: references('User'),
  })
  .describe(
    'A versioned, delivery-ready grouping of resource categories referenced by activity items.',
  )
  .as('ResourceSet');

export { resourceSet as resourceSetSchema };
